export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/productSubtype/state.js